import axios from 'axios';

const GEO_REGION_CACHE_KEY = 'geo_region_cache';
const DEFAULT_REGION = 'unknown';
const IPAPI_TIMEOUT_MS = 5000;

const IpUtils = {
  cachedIp: null,

  getRegionCache() {
    try {
      const raw = sessionStorage.getItem(GEO_REGION_CACHE_KEY);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  setRegionCache(ip, region) {
    try {
      sessionStorage.setItem(GEO_REGION_CACHE_KEY, JSON.stringify({ ip, region }));
    } catch (error) {
      console.warn('Failed to cache geo region:', error);
    }
  },

  getFallbackRegion() {
    return localStorage.getItem('user_region') || DEFAULT_REGION;
  },

  async getIpAddress() {
    try {
      if (this.cachedIp) {
        return this.cachedIp;
      }

      const response = await axios.get('https://api.ipify.org?format=json');
      this.cachedIp = response.data.ip;
      return this.cachedIp;
    } catch (error) {
      console.error('Error fetching IP:', error);
      return '127.0.0.1';
    }
  },

  async getRegion() {
    const ip = await this.getIpAddress();

    const cached = this.getRegionCache();
    if (cached?.ip === ip && cached?.region) {
      return cached.region;
    }

    try {
      const response = await axios.get(`https://ipapi.co/${ip}/json/`, {
        timeout: IPAPI_TIMEOUT_MS
      });
      const region = response.data?.country_name;
      if (region) {
        this.setRegionCache(ip, region);
        return region;
      }
    } catch (error) {
      console.warn('IP region lookup failed, using fallback:', error.message);
    }

    return this.getFallbackRegion();
  },

  clearCache() {
    this.cachedIp = null;
    try {
      sessionStorage.removeItem(GEO_REGION_CACHE_KEY);
    } catch {
      // ignore storage errors
    }
  }
};

export default IpUtils;